import React, { useEffect, useState } from 'react';
import './scrollup.css';

const ScrollUp = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY >= 560);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

  return (
    <a href="#home" className={visible ? "scroll_up show-scroll" : "scroll_up"}>
        <i className="uil uil-arrow-up scroll_up_icon"></i>
    </a>
  )
}

export default ScrollUp
